import { render, staticRenderFns } from "./NumberControl.vue?vue&type=template&id=c2d1cce2&"
import script from "./NumberControl.vue?vue&type=script&lang=ts&"
export * from "./NumberControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.2_1ebeed51c9db1c19ddd7ada5173f91fd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports